import { ReactComponent as SlidesFill } from 'assets/icons/icon-slides-fill.svg';

export default SlidesFill;
